<app-iframe
  #appIframe
  [route]="monolithRoute$ | async"
  [loading]="loading$ | async"
>
</app-iframe>
